import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShrinkScreen"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.21973 16.7198H9.96973V15.2198H3.21973V5.46976H19.7197V12.2198H21.2197V5.46976C21.2189 4.64167 20.5478 3.97058 19.7197 3.96976H3.21973C2.39164 3.97058 1.72055 4.64167 1.71973 5.46976V15.2198C1.72055 16.0478 2.39164 16.7189 3.21973 16.7198ZM12.75 21H21C21.8279 20.9988 22.4987 20.3279 22.5 19.5V15C22.4987 14.1721 21.8279 13.5012 21 13.5H12.75C11.9219 13.5008 11.2508 14.1719 11.25 15V19.5C11.2508 20.3281 11.9219 20.9992 12.75 21ZM12.75 15V19.5H21.0015L21 15H12.75ZM8.99998 10.1895V7.50001H10.5V12.75H5.24998V11.25H7.93948L4.71973 8.03026L5.78023 6.96976L8.99998 10.1895Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShrinkScreen.vue"]]);
